// import services from '@/config/services'
import Service from '@/services/ask-management/contratti-vendita-service'
import { app } from '@/main'

// const source = 'contrattiVenditaDataTable'
// const baseUrl = `${services.ask_api.url}/management`

const insertIbans = async function(file){
  const eventBus = app.config.globalProperties.$eventBus;
  const http = app.config.globalProperties.$http;
  const service = new Service(http, eventBus)

  const fd = new FormData()
  fd.append('file[]', file)
  await service.insertIbans(fd)
  .then((res) => {    
    this.$eventBus.emit('show-dialog-page', {
      page: 'ReportInsertMassiveIban',
      title: 'Report inserimento massivo IBAN',
      data: {
        data: res.items,
        headings: ['CODE', 'CF_CLIENTE', 'IBAN', 'ESITO']
      }
    })    
  })
}

export default {
  'bindTo': 'this',
  'method': insertIbans,
  'uploadFile': true,
}
